import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Sector} from './sector.model';
import * as SectorActions from './sector.actions';

export const sectorsFeatureKey = 'sectors';

export interface State extends EntityState<Sector> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Sector> = createEntityAdapter<Sector>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(SectorActions.addSector,
    (state, action) => adapter.addOne(action.sector, state)
  ),
  on(SectorActions.upsertSector,
    (state, action) => adapter.upsertOne(action.sector, state)
  ),
  on(SectorActions.addSectors,
    (state, action) => adapter.addMany(action.sectors, state)
  ),
  on(SectorActions.upsertSectors,
    (state, action) => adapter.upsertMany(action.sectors, state)
  ),
  on(SectorActions.updateSector,
    (state, action) => adapter.updateOne(action.sector, state)
  ),
  on(SectorActions.updateSectors,
    (state, action) => adapter.updateMany(action.sectors, state)
  ),
  on(SectorActions.deleteSector,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(SectorActions.deleteSectors,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(SectorActions.loadSectors,
    (state, action) => adapter.setAll(action.sectors, state)
  ),
  on(SectorActions.clearSectors,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
